export function validName(name: string): boolean {
    if (!name.includes('{{') && !name.includes('}}')) return true;

    const stack: string[] = [];
    const chars = [...name];

    chars.forEach((_, i) => {
        if (chars[i] === '{') {
            stack.push('{');
        }

        if (chars[i] === '}') {
            stack.pop();
        }
    });

    if (stack.length !== 0) return false;

    const regex = /\s*({{(.*?)}})\s*/g;
    const matches = name.match(regex);

    if (!matches) return false;

    for (const match of matches) {
        const trimmed = match.trim();
        if (!(trimmed === '{{task.name}}' || trimmed === '{{task.address}}')) {
            return false;
        }
    }

    return true;
}
